import { Box, Typography } from "@mui/material";
import type { PropsWithChildren } from "react";

const UnsupportedField = ({ children }: PropsWithChildren) => {
  return (
    <Box
      sx={[
        {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "2.5rem",
          width: "100%",
        },
        (t) => ({ border: `1px dashed ${t.palette.divider}` }),
      ]}
    >
      <Typography variant="caption" sx={{ color: "warning.main" }}>
        {children}
      </Typography>
    </Box>
  );
};

export default UnsupportedField;
